// Re-emit title/canonical/og from nuxtApp.payload.seo so SEO survives
// page-chunk load failures on Google WRS. Reads once from the SSR payload
// then clears it — page-level useHead handles client navigations.

import { cleanDoubleSlashes } from 'ufo'
import { toPublicLocalePath } from '@design-system/utils/publicLocalePath'

export default defineNuxtPlugin({
  name: 'seo-from-payload',
  enforce: 'pre',
  setup() {
    if (import.meta.server) return
    if (useRuntimeConfig().public.isFederated) return

    const nuxtApp = useNuxtApp()
    const entry = nuxtApp.payload.seo

    if (!entry) return

    const route = useRoute()

    nuxtApp.payload.seo = undefined

    const title = entry.title || 'Armani'

    useHead(() => {
      const { origin, pathname } = useRequestURL()
      const path = route.path && route.path !== '/' ? route.path : pathname
      return {
        titleTemplate: '%s',
        title,
        link: [
          {
            rel: 'canonical',
            href: cleanDoubleSlashes(
              `${origin}${toPublicLocalePath(
                path.startsWith('/') ? path : `/${path}`
              )}/`
            ),
          },
        ],
        meta: [
          { property: 'og:title', content: title },
          ...(entry.description
            ? [
                { name: 'description', content: entry.description },
                { property: 'og:description', content: entry.description },
              ]
            : []),
        ],
      }
    })
  },
})
